export default "__VITE_ASSET__BV4r27rs__"